import HousekeepingStatusBoardDispatcher from '../dispatcher/HousekeepingStatusBoardDispatcher';
import HousekeepingStatusBoardConstants from '../constants/HousekeepingStatusBoardConstants';
import { format, parseISO } from 'date-fns';

var objectAssign = require('object-assign');
var EventEmitter = require('events').EventEmitter.prototype;

var HousekeepingStatusBoardStore = objectAssign({}, EventEmitter, {
  _state: {
    currentDate: new Date(),
    dataTableEndpoint: null,
    dateFormat: null,
    loading: false,
    readOnly: false,
    reservationSegments: [],
    requestCleaningPath: null,
    timeFormat: null,
    activeTab: 'daily',
    dateData: {},
    roomTypes: []
  },

  emitChange() {
    this.emit(HousekeepingStatusBoardConstants.CHANGE_EVENT);
  },

  addChangeListener(callback) {
    this.on(HousekeepingStatusBoardConstants.CHANGE_EVENT, callback);
  },

  removeChangeListener(callback) {
    this.removeListener(HousekeepingStatusBoardConstants.CHANGE_EVENT, callback);
  },

  init(opts) {
    objectAssign(this._state, opts);
    if (opts.currentDate) {
      this._state.currentDate = parseISO(opts.currentDate);
    }

    // rehydrate activeTab
    const activeTabParam = new URLSearchParams(window.location.search).get("view");
    if (activeTabParam) {
      localStorage.setItem('HousekeepingStatusBoard|activeTab', activeTabParam);
    }
    
    const activeTabCookie = localStorage.getItem('HousekeepingStatusBoard|activeTab');
    if (activeTabParam) {
      this._state.activeTab = activeTabParam;
    } else if (activeTabCookie) {
      this._state.activeTab = activeTabCookie;
    }

    this.emitChange();
  },

  gotoDate(date) {
    this._state.currentDate = date;
    if (history.pushState) {
      var new_url = window.location.protocol + "//" + window.location.host + window.location.pathname + '?date=' + format(date, 'yyyy-MM-dd');
      window.history.pushState({path: new_url}, '', new_url);
    }
    this.emitChange();
  },

  setActiveTab(tab) {
    this._state.activeTab = tab;
    localStorage.setItem('HousekeepingStatusBoard|activeTab', tab);
    this.emitChange();
  },

  setLoading(loading) {
    this._state.loading = loading;
    this.emitChange();
  },

  getCurrentDate() {
    return this._state.currentDate;
  },

  getDataTableEndpoint() {
    return '/admin/housekeeping/date/' + format(this._state.currentDate, 'yyyy-MM-dd') + '?view=' + this._state.activeTab;
  },

  getDateFormat() {
    return this._state.dateFormat;
  },

  getLoading() {
    return this._state.loading;
  },

  getReadOnly() {
    return this._state.readOnly;
  },

  getReservationSegments() {
    return this._state.reservationSegments;
  },

  getRequestCleaningPath() {
    return this._state.requestCleaningPath;
  },

  getTimeFormat() {
    return this._state.timeFormat;
  },

  getActiveTab() {
    return this._state.activeTab;
  },

  getDateData() {
    return this._state.dateData;
  },

  getRoomTypes() {
    return this._state.roomTypes;
  },

  updateBoardData(data) {
    // Reset all data first
    this._state.dateData = {};
    this._state.roomTypes = [];
    this._state.reservationSegments = [];
    
    // Then update with new data
    if (data.date_data) {
      this._state.dateData = data.date_data;
    }
    if (data.room_types) {
      this._state.roomTypes = data.room_types;
    }
    if (data.reservation_segments) {
      this._state.reservationSegments = data.reservation_segments;
    }
    this.emitChange();
  },

  expandCollapseRoomType(roomType, collapsed) {
    for (var i = 0, ilen = this._state.roomTypes.length; i < ilen; i++) {
      if (this._state.roomTypes[i].id === roomType.id) {
        this._state.roomTypes[i].collapsed = collapsed;
        break;
      }
    }
    this.emitChange();
  }
});

HousekeepingStatusBoardStore.dispatchToken = HousekeepingStatusBoardDispatcher.register(function(payload) {
  switch (payload.action) {
    case HousekeepingStatusBoardConstants.INIT:
      HousekeepingStatusBoardStore.init(payload.opts);
      break;

    case HousekeepingStatusBoardConstants.GOTO_DATE:
      HousekeepingStatusBoardStore.gotoDate(payload.date);
      break;

    case HousekeepingStatusBoardConstants.SET_ACTIVE_TAB:
      HousekeepingStatusBoardStore.setActiveTab(payload.tab);
      break;

    case HousekeepingStatusBoardConstants.SET_LOADING:
      HousekeepingStatusBoardStore.setLoading(payload.loading);
      break;

    case HousekeepingStatusBoardConstants.UPDATE_BOARD_DATA:
      HousekeepingStatusBoardStore.updateBoardData(payload.data);
      break;

    case HousekeepingStatusBoardConstants.EXPAND_COLLAPSE_ROOM_TYPE:
      HousekeepingStatusBoardStore.expandCollapseRoomType(payload.roomType, payload.collapsed);
      break;

    default:
      return;
  }
});

/* silence the EventEmitter */
HousekeepingStatusBoardStore.setMaxListeners(0);

export default HousekeepingStatusBoardStore;